import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import Cookies from 'js-cookie';
import '../css/header.css';

const Header = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    
    // Read the user's college from the cookie
    const userCollege = Cookies.get('college') || 'main'; // defaults to 'main' if not found for safety

    const handleLogout = () => {
        // Clear all session cookies
        Cookies.remove('email');
        Cookies.remove('ec_auth_token');
        Cookies.remove('token');
        Cookies.remove('college');
        Cookies.remove('permissions');
        Cookies.remove('allowed_forms');
        window.location.href = '/';
    };

    const toggleMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    // Automatically close the mobile menu if the screen is resized to desktop width
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 992) {
                setIsMobileMenuOpen(false);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <header className="premium-header">
            <div className="header-container">
                {/* Logo Section */}
                <div className="logosec">
                    <NavLink to="/" className="logo-link">
                        <img src="/images/ethiccraft_full_logo.png" alt="EthicCraft Logo" className="header-logo-img" />
                    </NavLink>
                </div>

                {/* Mobile Hamburger Button */}
                <button 
                    className={`mobile-menu-btn ${isMobileMenuOpen ? 'active' : ''}`} 
                    onClick={toggleMenu} 
                    aria-label="Toggle Navigation"
                >
                    <span className="hamburger-line"></span>
                    <span className="hamburger-line"></span>
                    <span className="hamburger-line"></span>
                </button>

                {/* Navigation Menu */}
                <nav className={`nav-links ${isMobileMenuOpen ? 'open' : ''}`}>
                    <NavLink 
                        to="/forms" 
                        className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}
                        onClick={() => setIsMobileMenuOpen(false)}
                    >
                        All Tables
                    </NavLink>
                    <NavLink 
                        to="/eventtickets" 
                        className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}
                        onClick={() => setIsMobileMenuOpen(false)}
                    >
                        Event Tickets
                    </NavLink>
                    <NavLink 
                        to="/report" 
                        className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}
                        onClick={() => setIsMobileMenuOpen(false)}
                    >
                        Reports
                    </NavLink>
                    
                    {/* Conditionally render the Colleges tab only for main admin */}
                    {userCollege === 'main' && (
                        <NavLink 
                            to="/collegeactivities" 
                            className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}
                            onClick={() => setIsMobileMenuOpen(false)}
                        >
                            Colleges
                        </NavLink>
                    )}
                    
                    {/* Logout Button */}
                    <button onClick={handleLogout} className="nav-item logout-btn">
                        Logout
                    </button>
                </nav>
            </div>

            {/* Mobile Menu Background Overlay */}
            <div 
                className={`mobile-menu-overlay ${isMobileMenuOpen ? 'open' : ''}`}
                onClick={() => setIsMobileMenuOpen(false)}
            ></div>
        </header>
    );
};

export default Header;